export default {"src":"/_next/static/media/geist-finance.4ed48e20.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};